import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { apiBaseUrlInterceptor } from './app/interceptors/api-base-url.interceptor';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { subscriptionInterceptor } from './app/interceptors/subscription.interceptor';

// Initialize console logging toggle based on environment.enableConsoleLogging
(function () {
  try {
    const enabled = (environment as any).enableConsoleLogging !== false;
    if (!enabled) {
      const noop = () => {};
      const c = console as any;
      c.log = noop;
      c.info = noop;
      c.debug = noop;
      c.warn = noop;
      c.table = noop;
      c.trace = noop;
    }
  } catch { /* empty */ }
})();

// High-visibility startup log to verify build and environment in production
try {
  (window as any).__CCN_BUILD__ = environment.buildNumber;
  console.info('[App Startup] Kickstart Tech Stack Frontend starting', {
    buildNumber: environment.buildNumber,
    production: environment.production,
    apiUrl: environment.apiUrl,
  });
} catch { /* empty */ }

bootstrapApplication(AppComponent, {
  providers: [
    // Ensure base URL rewrite happens before auth header injection
    provideHttpClient(withInterceptors([
      apiBaseUrlInterceptor,
      authInterceptor,
      subscriptionInterceptor,
    ])),
    provideRouter(routes),
    provideIonicAngular(),
  ],
}).catch(err => console.error(err));
